import { APP_INITIALIZER, NgModule } from '@angular/core'
import { MbSubmitOrderModule } from './components/mb-submit-order/mb-submit-order.module'
import { ImportExportCartModule } from './components/import-export-cart/import-export-cart.module'
import { QuickAddToCartModule } from './components/quick-add-to-cart/quick-add-to-cart.module'
import { MbPaymentMethodsModule } from './components/mb-payment-methods/mb-payment-methods.module'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { IconModule, MediaModule } from '@spartacus/storefront'
import { PageMetaResolver, UrlModule } from '@spartacus/core'
import { QuantityCounterModule } from '../shared/components/quantity-counter/quantity-counter.module'
import { MbAddToCartModule } from './components/mb-add-to-cart/mb-add-to-cart.module'
import { MbEmptyCartModule } from './components/mb-empty-cart/mb-empty-cart.module'
import { MbI18nModule } from '../translations/mb-i18n.module'
import {
  ViewMultiValueDialogModule
} from '../product/components/product-line/view-multi-value-dialog/view-multi-value-dialog.module'
import { MbCartDetailsModule } from './components/mb-cart-details/mb-cart-details.module'
import { MiltenyiCartPageMetaResolver } from './services/miltenyi-cart-page-meta.resolver'
import { MbMultiCartStoreModule } from './store/mb-multi-cart-store.module'
import { mbFacadeProviders } from './facades/mb-facades-providers'
import { MbActiveCartService } from './services/mb-active-cart.service'
import { MbAfterCartMigrationService } from './services/mb-after-cart-migration.service'
import { MbCartPoUploadModule } from './components/mb-cart-po-upload/mb-cart-po-upload.module'
import { MbOccSaveCartAdapter } from './adapters/mb-occ-save-cart.adapter'
import { CartItemContextSource } from '@spartacus/cart/base/components'
import { WishListService } from '@spartacus/cart/wish-list/core'
import { ActiveCartService, CartAdapter } from '@spartacus/cart/base/core'
import { ActiveCartFacade } from '@spartacus/cart/base/root'
import { MbWishListService } from '../wishlist/services/mb-wishlist.service'
import { MbWishlistAdapter } from '../wishlist/connectors/mb-wishlist.adapter'
import { MbOccWishlistAdapter } from '../wishlist/adapters'
import { MbAnalyticsStoreModule } from '../analytics/store/mb-analytics-store.module'

@NgModule({
  imports: [
    MbI18nModule,
    CommonModule,
    RouterModule,
    MediaModule,
    UrlModule,
    IconModule,
    QuickAddToCartModule,
    MbSubmitOrderModule,
    ImportExportCartModule,
    MbPaymentMethodsModule,
    MbAddToCartModule,
    QuantityCounterModule,
    MbEmptyCartModule,
    ViewMultiValueDialogModule,
    MbCartDetailsModule,
    MbMultiCartStoreModule,
    MbAnalyticsStoreModule,
    MbCartPoUploadModule
  ],
  providers: [
    ...mbFacadeProviders,
    CartItemContextSource,
    {
      provide: CartAdapter,
      useExisting: MbOccSaveCartAdapter
    },
    {
      provide: WishListService,
      useExisting: MbWishListService
    },
    {
      provide: MbWishlistAdapter,
      useExisting: MbOccWishlistAdapter
    },
    {
      provide: PageMetaResolver,
      useExisting: MiltenyiCartPageMetaResolver,
      multi: true,
    },
    {
      provide: ActiveCartFacade,
      useExisting: MbActiveCartService
    },
    {
      provide: ActiveCartService,
      useExisting: MbActiveCartService
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (afterCartMigrationService: MbAfterCartMigrationService) => () => afterCartMigrationService.ngOnInit(),
      deps: [MbAfterCartMigrationService],
      multi: true
    }
  ]
})
export class CartModule {
}
